<template>
  <div>
    <basic-alert :active="alertActive" :type="alertType" :msg="alertMsg" />
    <view-container>
      <v-container>
        <v-row>
          <v-col cols="2">
            <basic-btn
              xLarge
              icon="mdi-arrow-left"
              style="margin: 7px"
              @click="
                pasos === 1
                  ? $router.push('/client/Search')
                  : (pasos = pasos - 1)
              "
            />
          </v-col>
          <v-col cols="10">
            <h1
              v-text="
                pasos === 1
                  ? 'Elige aquí el tipo de espacio que necesitas'
                  : pasos === 2
                  ? 'Seleccione las fechas que necesites'
                  : 'Reserva: Lugar De Trabajo'
              "
            />
          </v-col>
        </v-row>
        <v-spacer></v-spacer>
        <v-row>
          <v-col cols="12" sm="12" md="12"> </v-col>
          <v-col cols="12" sm="12" md="12" class="out-padding">
            <auto-container
              style="overflow: auto;"
              :dimension="'100'"
              color="#F7F9F9"
            >
              <v-stepper
                v-model="pasos"
                class="stepsClass"
                style="box-shadow: 0 0px 0px 0px rgba(0,0,0,.2),0 0px 0 rgba(0,0,0,.14),0 0px 0px 0 rgba(0,0,0,.12);
            background-color:#F7F9F9"
              >
                <v-stepper-content step="1">
                  <v-container>
                    <v-row>
                      <v-col>
                        <h2 v-text="'Caracteristicas'" class="colorLinde2" />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <h3 v-text="'Tipo De Espacio'" class="colorLinde" />
                      </v-col>
                      <v-col cols="6">
                        <select-up
                          :info="reservationType"
                          @click="listInfo"
                          formReserv="tipo"
                          :key="newReservation"
                          selectText="Selecciona tu espacio"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="6"
                        sm="6"
                        md="6"
                        lg="6"
                        xs="6"
                        v-if="
                          role == 'gerente' ||
                            role == 'administrador' ||
                            role == 'gerente'
                        "
                      >
                        <h3
                          v-text="'Otras Caracteristicas'"
                          class="colorLinde"
                        />
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="
                        newForm['tipo']
                          ? newForm['tipo'].codigo == 'SJ'
                            ? true
                            : false
                          : false
                      "
                    >
                      <v-col cols="6" sm="6" md="6" lg="6" xs="6">
                        <h3 v-text="'Capacidad'" class="colorLinde" />
                      </v-col>
                      <v-col cols="6" sm="6" md="6" lg="6" xs="6">
                        <input-btn
                          @click="btnInfo"
                          number
                          formReserv="capacidad"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="multiplePermission && newForm['tipo']">
                      <v-col cols="6" sm="6" md="6" lg="6" xs="6">
                        <h3
                          v-text="'¿Es para otra persona?'"
                          class="colorLinde"
                        />
                      </v-col>
                      <v-col class="float-right" cols="6">
                        <v-checkbox
                          v-model="other"
                          color="secondary"
                          class="float-right"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row v-if="multiplePermission && other">
                      <v-col cols="6" sm="6" md="6" lg="6" xs="6">
                        <h3 v-text="'Otra persona:'" class="colorLinde" />
                      </v-col>
                      <v-col cols="6" sm="6" md="6" lg="6" xs="6">
                        <v-autocomplete
                          single-line
                          outlined
                          color="primary"
                          background-color="white"
                          class="rounded-0"
                          label="Otra persona"
                          prepend-inner-icon=""
                          append-icon=""
                          v-model="otherId"
                          item-text="fullName"
                          item-value="id"
                          :items="employees"
                          hide-no-data
                          :search-input.sync="search"
                          @update:search-input="getEmployees()"
                          clearable
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12"> </v-col>
                    </v-row>
                  </v-container>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <v-container
                    v-if="
                      newForm['tipo']
                        ? newForm['tipo'].codigo[0] === '1'
                        : false
                    "
                  >
                    <v-row>
                      <v-col cols="12">
                        <h2
                          v-text="'Selecciona las fechas que necesites'"
                          class="colorLinde2"
                        />
                      </v-col>
                      <v-col cols="12">
                        <vc-calendar
                          is-expanded
                          v-model="date"
                          :attributes="attributes"
                          @dayclick="onDayClick"
                          :min-date="new Date()"
                          :max-date="limitDay()"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <h2
                          v-text="'Selecciona tu hora de entrada'"
                          class="colorLinde2"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-dialog
                          ref="dialog"
                          v-model="modal2"
                          :return-value.sync="time"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="time"
                              label="Seleccione"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              single-line
                              outlined
                              color="primary"
                              background-color="white"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            v-if="modal2"
                            v-model="time"
                            full-width
                            :allowed-minutes="allowedStep"
                            :allowed-hours="allowedHours"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modal2 = false">
                              Cancelar
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialog.save(time)"
                            >
                              Aceptar
                            </v-btn>
                          </v-time-picker>
                        </v-dialog>
                      </v-col>
                    </v-row>
                  </v-container>

                  <v-container
                    v-if="
                      newForm['tipo']
                        ? newForm['tipo'].codigo[0] !== '1'
                        : false
                    "
                  >
                    <v-row>
                      <v-col cols="12">
                        <h2 v-text="'Fecha de inicio'" class="colorLinde2" />
                        <week-btn
                          :value="increment"
                          @click="selectDayBegin"
                          formReserv="inicio"
                          style="margin:0px; padding: 0px"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <h2 v-text="'Hora y duracion'" class="colorLinde2" />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" lg="6" xs="6">
                        <h3 v-text="'Hora de inicio'" class="colorLinde" />
                      </v-col>
                      <v-col cols="6">
                        <v-dialog
                          ref="dialog"
                          v-model="modal2"
                          :return-value.sync="time"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="time"
                              label="Seleccione"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              single-line
                              outlined
                              color="primary"
                              background-color="white"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            v-if="modal2"
                            v-model="time"
                            full-width
                            :allowed-minutes="allowedStep"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modal2 = false">
                              Cancelar
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialog.save(time)"
                            >
                              Aceptar
                            </v-btn>
                          </v-time-picker>
                        </v-dialog>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" lg="6" xs="6">
                        <h3 v-text="'Duración'" class="colorLinde" />
                      </v-col>
                      <v-col class="text-center" cols="6">
                        <input-btn @click="btnInfo" formReserv="duracion" />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <h2 v-text="'Periodicidad'" class="colorLinde2" />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <h4
                          v-text="'Frecuencia de la reunión'"
                          class="colorLinde"
                        />
                      </v-col>
                      <v-col cols="6">
                        <select-up
                          :info="repeat"
                          @click="listInfo"
                          formReserv="repite"
                          :clean="cleanSelectsRepeat"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="
                          newForm['repite']
                            ? newForm['repite'].id !== noneRepetitionsId
                              ? true
                              : false
                            : false
                        "
                      >
                        <h2
                          v-text="'Fecha fin de las reservaciones periódicas:'"
                          class="colorLinde2"
                        />
                        <week-btn
                          :value="increment"
                          @click="selectDayEnd"
                          formReserv="fin"
                          :beginLimit="newForm['inicio']"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <v-container>
                    <v-row class="pa-3">
                      <h1
                        class="
                      text-h4            
                      text-md-h6         
                      text-lg-h6         
                      text-xl-h6
                      font-weight-bold          
                      text-truncate"
                        v-text="'Piso Y Area'"
                        style="color: #005591"
                      />
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <span v-text="'Piso'" class="colorLinde" />
                        <select-up
                          :info="clickInfo"
                          text="piso"
                          formReserv="piso"
                          @change="listInfo"
                          @click="listInfo"
                          :key="newClick"
                          :clean="cleanSelects"
                          :checkFirst="pasos === 3 ? true : false"
                        />
                      </v-col>
                      <v-col cols="6">
                        <span v-text="'Area'" class="colorLinde" />
                        <select-up
                          :info="areasInfo"
                          @change="listInfo"
                          @click="listInfo"
                          formReserv="area"
                          :key="newArea"
                          :clean="cleanSelects"
                          :checkFirst="pasos === 3 ? true : false"
                        />
                      </v-col>
                      <v-col cols="12">
                        <h4
                          class="
                          text-center
                          text-h4            
                          text-md-h6         
                          text-lg-h6         
                          text-xl-h6
                          font-weight-Light          
                          text-truncate"
                          v-text="'Selecciona los campos faltantes.'"
                          style="color: #005591"
                          v-if="hiddenCnavas"
                        />
                        <div class="scroll-container">
                          <canvas
                            class="scroll-container"
                            v-on:mousemove="findPlace"
                            v-on:click="bootomModal"
                            style="
                              max-width: 250% 
                            "
                            id="myArea"
                            :hidden="hiddenCnavas"
                          ></canvas>
                          <v-progress-circular
                            :size="50"
                            color="primary"
                            indeterminate
                            v-if="searchImg"
                          />
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-stepper-content>
              </v-stepper>
              <v-row style=" position: relative;bottom:-20%">
                <v-col cols="2"></v-col>
                <v-col
                  align-self="center"
                  cols="8"
                  style="padding-bottom: 30px"
                >
                  <basic-btn
                    v-if="pasos !== 3"
                    block
                    text="Siguiente"
                    @click="pasos = pasos + 1"
                    colorBtn="primary"
                    :disabled="botonSiguiente"
                  />
                </v-col>
                <v-col cols="2"></v-col>
              </v-row>
            </auto-container>
          </v-col>
        </v-row>
      </v-container>
      <v-bottom-sheet v-model="sheet2">
        <v-sheet class="text-left" style="padding:2%">
          <v-row align="end" class="fill-height">
            <v-col align="center" cols="3">
              <v-avatar class="" size="100" tile>
                <v-img
                  :src="userInfo.imgURI ? host + userInfo.imgURI : userImg"
                ></v-img>
              </v-avatar>
            </v-col>
            <v-col class="float-left">
              <h2 style="color: #005591" v-text="'Espacio: ' + spaceName" />
              <br />
              <span class="font-weight-bold colorLinde" v-text="'Nombre'" />
              <p
                style="color: #005591"
                v-text="userInfo.nombre + ' ' + userInfo.apellidoPaterno"
              />
              <span class="font-weight-bold colorLinde" v-text="'Puesto'" />
              <p style="color: #005591" v-text="userInfo.puesto" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-container>
                <v-row>
                  <h1
                    style="color: #005591"
                    v-text="'Detalles de la reserva'"
                  />
                </v-row>
                <v-row>
                  <span class="colorLinde" v-text="'Ubicación: '" />
                  <span class="colorLinde2" v-text="ubicacionName" />
                </v-row>
                <v-row>
                  <span class="colorLinde" v-text="'Espacio reservado: '" />
                  <span class="colorLinde2" v-text="spaceName" />
                </v-row>
                <v-row>
                  <span
                    class="colorLinde"
                    v-text="'La reservacion es para mí: '"
                  />
                  <span class="colorLinde2" v-text="other ? 'No' : 'Si'" />
                </v-row>
                <v-row v-if="otherEmployee != ''">
                  <span class="colorLinde" v-text="'La va utilizar: '" />
                  <span class="colorLinde2" v-text="otherEmployee" />
                </v-row>
                <v-row>
                  <span class="colorLinde" v-text="'Número de personas: '" />
                  <span
                    class="colorLinde2"
                    v-text="
                      newForm['capacidad'] == '' ? newForm['capacidad'] : '1'
                    "
                  />
                </v-row>
                <v-row>
                  <span class="colorLinde" v-text="'Días: '" />
                </v-row>
                <v-row v-for="item in arrayDays" :key="item.key">
                  <span class="colorLinde2">
                    {{ item ? item : moment(new Date(this.newForm.inicio)) }}
                    <br />
                  </span>
                </v-row>

                <v-row>
                  <span class="colorLinde" v-text="'Hora de inicio: '" />
                  <span class="colorLinde2" v-text="time" />
                </v-row>
              </v-container>
            </v-col>
          </v-row>
          <br />
          <br />
          <br />
          <v-row>
            <v-col cols="3"> </v-col>
            <v-col cols="6">
              <basic-btn
                block
                colorBtn="primary"
                text="Reservar"
                @click="classReservation"
                :disabled="!spaceAvaible"
                :load="loadResev"
              />
            </v-col>
            <v-col cols="3"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="3"> </v-col>
            <v-col cols="6">
              <basic-btn
                block
                text="Agregar al Carrito"
                @click="createCart(1)"
              />
            </v-col>
            <v-col cols="3"> </v-col>
          </v-row>
        </v-sheet>
      </v-bottom-sheet>
      <v-bottom-sheet v-model="sheet3">
        <v-sheet class="text-left" style="padding:2%">
          <auto-container :dimension="'50'" color="white" borderOff>
            <h2 class="colorLinde" v-text="ubicacionName" />
            <h2 class="colorLinde" v-text="spaceName" />
            <v-container>
              <v-sheet :height="240">
                <v-calendar
                  ref="calendar"
                  :now="calendarDay"
                  :value="calendarDay"
                  :events="events"
                  color="primary"
                  type="day"
                  locale="es-MX"
                ></v-calendar>
              </v-sheet>
              <basic-btn
                block
                colorBtn="primary"
                text="Reservar"
                @click="classReservation"
                :disabled="!spaceAvaible"
                :load="loadResev"
              />
              <br />
              <basic-btn
                block
                text="Agregar al Carrito"
                @click="createCart(2)"
              />
            </v-container>
          </auto-container>
        </v-sheet>
      </v-bottom-sheet>
      <v-row justify="center">
        <v-dialog v-model="resume" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="text-h5 colorLinde"
                >¡Tu espacio está reservado!</span
              >
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <span class="colorLinde" v-text="'Ubicación: '" />
                  <span class="colorLinde2" v-text="ubicacionName" />
                </v-row>
                <v-row>
                  <span class="colorLinde" v-text="'Espacio reservado: '" />
                  <span class="colorLinde2" v-text="spaceName" />
                </v-row>
                <v-row>
                  <span
                    class="colorLinde"
                    v-text="'La reservacion es para mi: '"
                  />
                  <span class="colorLinde2" v-text="other ? 'No' : 'Si'" />
                </v-row>
                <v-row>
                  <span class="colorLinde" v-text="'Número de personas: '" />
                  <span
                    class="colorLinde2"
                    v-text="
                      newForm['capacidad'] == '' ? newForm['capacidad'] : '1'
                    "
                  />
                </v-row>
                <v-row
                  v-if="
                    newForm['tipo'] ? newForm['tipo'].codigo[0] === '1' : false
                  "
                >
                  <span class="colorLinde2" v-text="'Días: '" />
                </v-row>
                <v-row
                  v-if="
                    newForm['tipo'] ? newForm['tipo'].codigo[0] === '1' : false
                  "
                >
                  <v-container>
                    <v-row
                      class="colorLinde"
                      v-for="item in arrayDays"
                      :key="item.key"
                    >
                      <span v-text="item" />
                      <br />
                    </v-row>
                  </v-container>
                </v-row>
                <v-row v-else>
                  <span class="colorLinde" v-text="'Fecha de inicio: '" />
                  <span class="colorLinde2">
                    {{
                      moment(new Date(newForm["inicio"] + " " + time)).format(
                        "yyyy-MM-DD HH:mm"
                      )
                    }}
                  </span>
                </v-row>
                <v-row>
                  <span class="colorLinde" v-text="'Duración: '" />
                  <span
                    v-if="
                      newForm['tipo']
                        ? newForm['tipo'].codigo[0] !== '1'
                        : false
                    "
                    class="colorLinde2"
                    v-text="duration"
                  />
                  <span v-else class="colorLinde2" v-text="'Todo el día'" />

                  <br />
                </v-row>
                <v-row
                  v-if="
                    newForm['tipo'] ? newForm['tipo'].codigo[0] !== '1' : false
                  "
                >
                  <span class="colorLinde" v-text="'Periodicidad: '" />
                  <span class="colorLinde2" v-text="repeatActive" />
                  <br />
                </v-row>
                <v-row
                  v-if="
                    newForm['tipo'] ? newForm['tipo'].codigo[0] !== '1' : false
                  "
                >
                  <span
                    class="colorLinde"
                    v-text="
                      'Fecha fin ' +
                        (repeatActive === 'Ninguna' ? ': ' : 'periodicidad: ')
                    "
                  />
                  <span class="colorLinde2" v-text="finishDay" />
                  <br />
                </v-row>
                <v-row>
                  <br />
                  <basic-btn
                    block
                    colorBtn="primary"
                    text="Listo"
                    @click="$router.push('/client/Search')"
                  />
                  <br />
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </view-container>
  </div>
</template>

<script>
import moment from "moment";
import moment_tz from "moment-timezone";
import Scroller from "@/components/Scroller";
import VueJwtDecode from "vue-jwt-decode";
import { services } from "@/utils";
import { userImg } from "@/assets";

import {
  AutoContainer,
  ViewContainer,
  BasicInput,
  BasicBtn,
  SearchBox,
  InfoList,
  SelectBtn,
  WeekBtn,
  SelectUp,
  InputBtn,
  BasicAlert,
} from "@/components";

export default {
  name: "home",
  components: {
    AutoContainer,
    ViewContainer,
    BasicInput,
    BasicBtn,
    SearchBox,
    InfoList,
    SelectBtn,
    WeekBtn,
    Scroller,
    SelectUp,
    InputBtn,
    BasicAlert,
  },
  data: () => ({
    host: process.env.VUE_APP_API_SERVER,
    userImg: userImg,
    ubicacionId: undefined,
    ubicacionName: "No disppnible",
    zone: "No disponible",
    duration: "00:00",
    repeatActive: "Ninguna",
    auxMap: undefined,
    date: undefined,
    resume: false,
    alertActive: false,
    searchImg: false,
    search: null,
    multiplePermission: false,
    alertMsg: "",
    alertType: "error",
    otherId: undefined,
    spaceName: "",
    spaceAvaible: false,
    userInfo: [],
    spaceReserv: 0,
    noneRepetitionsId: 1,
    text: null,
    employees: [],
    sheet: false,
    sheet2: false,
    time: null,
    menu2: false,
    modal2: false,
    sheet3: false,
    loadResev: false,
    checkArea: false,
    forms: "",
    pasos: 1,
    changeDta: false,
    other: false,
    cleanSelects: false,
    cleanSelectsRepeat: false,
    role: [],
    capa: 0,
    areas: [],
    repeat: [],
    areasInfo: [],
    workplaces: [],
    vueCanvas: undefined,
    clickInfo: [],
    newClick: 1,
    newArea: 1,
    newReservation: 1,
    increment: "1",
    newForm: {
      piso: {
        areas: undefined,
      },
      tipo: undefined,
      repite: undefined,
      inicio: undefined,
      fin: undefined,
      area: undefined,
      capacidad: undefined,
      duracion: undefined,
    },
    id: "test",
    config: {
      multiple: 0.5,
      magnify: true,
      width: 400,
      height: 300,
      src: "",
      showBgImg: true,
    },
    layer: [],
    reservationType: [],
    arrayDays: [],
    days: [],
    events: [],
    focus: "2020-04-05",
    hiddenCnavas: false,
    events: [],
  }),
  mounted() {
    this.ubicacionId = this.$route.params.id;
    this.ubicacionName = this.$route.params.name
      ? this.$route.params.name
      : "Ubicacion desconocida";
    this.zone = this.$route.params.zone
      ? this.$route.params.zone
      : "Ubicacion desconocida";
    this.check();
    this.dataProfile();
    this.getRepetitions();
    this.getWorkplaces();
    this.getAreas();
  },
  computed: {
    dates() {
      return this.days.map((day) => day.date);
    },
    updateWorkplace() {
      return this.reservationType;
    },
    attributes() {
      return this.dates.map((date) => ({
        highlight: true,
        dates: date,
      }));
    },
    calendarDay() {
      return moment(new Date(this.newForm["inicio"]))
        .utc()
        .format("yyyy-MM-DD");
    },
    botonSiguiente() {
      if (this.newForm) {
        if (this.pasos == 1) {
          if (!this.newForm["tipo"]) {
            return true;
          } else if (this.other == true && !this.otherId) {
            return true;
          }
        }
        if (this.pasos == 2) {
          if (this.newForm["tipo"].codigo[0] == "1") {
            if (!this.time) {
              return true;
            }
            if (this.days.length == 0) {
              return true;
            }
          } else {
            if (!this.newForm["inicio"]) {
              return true;
            }
          }
        }
      }
      return false;
    },
    otherEmployee() {
      let empl = "";
      if (this.otherId) {
        for (let i = 0; i < this.employees.length; i++) {
          if (this.otherId == this.employees[i].id) {
            empl = this.employees[i].fullName;
          }
        }
      }
      return empl;
    },
    finishDay() {
      let init = moment(
        new Date(this.newForm["inicio"] + " " + this.time)
      ).format("yyyy-MM-DD HH:mm");
      let finish = moment(new Date(this.newForm["fin"] + " 00:00"))
        .endOf("day")
        .format("yyyy-MM-DD");

      return this.newForm["repite"]
        ? this.newForm["repite"].id == this.noneRepetitionsId
          ? moment(init).format("yyyy-MM-DD")
          : finish
        : finish;
    },
  },
  watch: {
    alertActive(new_val) {
      if (new_val) {
        setTimeout(() => {
          this.alertActive = false;
        }, 3000);
      }
    },
    pasos(new_val, old_val) {
      if (new_val) {
        if (old_val == 3) {
          this.hiddenCnavas = true;
          this.cleanSelects = !this.cleanSelects;
        }
      }
    },
    other(new_val, old_val) {
      if (new_val != old_val) {
        this.otherId = undefined;
      }
    },
  },
  methods: {
    allowedStep: (m) => m % 30 === 0,
    allowedHours: (v) => v >= 7 && v <= 9,
    reservation() {
      let userId = VueJwtDecode.decode(this.$session.get("jwt"));
      let data = {
        data: {
          fechaInicio: this.arrayDays[0],
          fechaFin: this.arrayDays[0],
          fechas: JSON.stringify(this.arrayDays),
          horaInicio: this.time,
          empleado: this.otherId ? this.otherId : userId.employee.id,
          comentarios: "",
          lugarTrabajo: this.spaceReserv,
          cantidadEmpleados: 1,
          duracionDiaria: this.newForm["duracion"]
            ? this.newForm["duracion"]
            : 1800,
          tipoRepeticion: this.newForm["repite"]
            ? this.newForm["repite"].id
            : this.noneRepetitionsId,
          zonaHoraria: moment_tz.tz.guess(),
        },
      };
      services
        .ws("post", "reservation", data)
        .then((res) => {
          this.resume = true;

          if (res.ok) {
            this.alertActive = true;
            this.alertMsg = "Se ha realizado con éxito su reserva";
            this.alertType = "success";
          } else {
            this.alertActive = true;
            this.alertMsg = res.message;
            this.alertType = "error";
          }
        })
        .finally(() => {
          this.loading = false;
          this.loadResev = false;
        });
    },
    reservation2() {
      let userId = VueJwtDecode.decode(this.$session.get("jwt"));
      let init = moment(new Date(this.newForm["inicio"] + " " + this.time))
        .utc()
        .format("yyyy-MM-DD HH:mm");
      let finish = moment(new Date(this.newForm["fin"] + " 00:00"))
        .endOf("day")
        .utc()
        .format("yyyy-MM-DD HH:mm");
      let data = {
        data: {
          fechaInicio: init,
          fechaFin: this.newForm["repite"]
            ? this.newForm["repite"].id == this.noneRepetitionsId
              ? moment(init)
                  .endOf("day")
                  .utc()
                  .format("yyyy-MM-DD HH:mm")
              : finish
            : finish,
          empleado: this.otherId ? this.otherId : userId.employee.id,
          comentarios: "",
          lugarTrabajo: this.spaceReserv,
          cantidadEmpleados: this.newForm["capacidad"]
            ? this.newForm["capacidad"]
            : 4,
          duracionDiaria: this.newForm["duracion"]
            ? this.newForm["duracion"]
            : 1800,
          tipoRepeticion: this.newForm["repite"]
            ? this.newForm["repite"].id
            : this.noneRepetitionsId,
          zonaHoraria: moment_tz.tz.guess(),
        },
      };
      services
        .ws("post", "reservation", data)
        .then((res) => {
          if (res.code) {
            this.alertActive = true;
            this.alertMsg = res.message;
            this.alertType = "error";
          } else {
            this.resume = true;
          }
        })
        .catch((error) => {
          this.alertActive = true;
          this.alertMsg = error.response.data.message;
          this.alertType = "error";
        })
        .finally(() => {
          this.loading = false;
          this.loadResev = false;
        });
    },
    classReservation() {
      this.loadResev = true;
      if (
        this.newForm["tipo"] ? this.newForm["tipo"].codigo[0] === "1" : false
      ) {
        this.reservation();
      } else {
        this.reservation2();
      }
    },
    check() {
      services
        .ws("get", "check")
        .then((res) => {
          if (res.ok) {
            this.role = res.data.roles;
          }
        })
        .catch((error) => {
          this.alertActive = true;
          this.alertMsg = error.response.data.message;
          this.alertType = "error";
        })
        .finally(() => {
          this.permissionCheck();
        });
    },
    isInside(point, place) {
      let pX = point.x;
      let pY = point.y;
      let x1 = place.x;
      let y1 = place.y;
      let x2 = place.x + place.w;
      let y2 = place.y + place.h;
      if (pX >= x1 && pX <= x2 && pY >= y1 && pY <= y2) {
        return true;
      }
    },
    findPlace(e) {
      let x = e.offsetX;
      let y = e.offsetY;
      for (let i = 0; i < this.workplaces.length; i++) {
        if (this.workplaces[i].disponible) {
          if (this.isInside({ x, y }, this.workplaces[i].coordenadas)) {
            this.auxMap = JSON.parse(JSON.stringify(this.workplaces[i]));
            this.openInfo = true;
            break;
          } else {
            this.openInfo = false;
          }
        }
      }
    },
    getLayout() {
      this.searchImg = true;
      let data = {
        areaID: this.newForm["area"].id,
      };
      services
        .ws("get", "layout", data, "params")
        .then((res) => {
          if (res.ok) {
            let layout = res.data.data;
            this.forms =
              "data:image/png;base64," +
              btoa(
                new Uint8Array(layout).reduce(
                  (data, byte) => data + String.fromCharCode(byte),
                  ""
                )
              );
          } else {
          }
        })
        .catch((error) => {
          this.alertActive = true;
          this.alertMsg = error.response.data.message;
          this.alertType = "error";
        })
        .finally(() => {
          this.searchImg = false;
          this.makeArea();
        });
    },
    makeArea() {
      var siteMarks = this.workplaces;

      this.loading = true;
      setTimeout(() => {
        const _this = this;
        function draw() {
          ctx.drawImage(baseImage, 0, 0, ctx.canvas.width, ctx.canvas.height);
          ctx.lineWidth = 2;
          for (let site of siteMarks) {
            ctx.strokeRect(
              site.coordenadas.x,
              site.coordenadas.y,
              site.coordenadas.w,
              site.coordenadas.h
            );
            if (site.disponible) {
              ctx.fillStyle = "rgba(0, 160, 225, 0.5)";
            } else {
              ctx.fillStyle = "#e100009f";
            }
            ctx.fillRect(
              site.coordenadas.x,
              site.coordenadas.y,
              site.coordenadas.w,
              site.coordenadas.h
            );
          }
        }
        function mainLoop() {
          if (
            _this.forms &&
            (refresh || mouse.down || mouse.up || mouse.button)
          ) {
            refresh = false;
            if (mouse.down) {
              mouse.down = false;
              rect.restart(mouse);
            } else if (mouse.button) {
              rect.update(mouse);
            } else if (mouse.up) {
              mouse.up = false;
              rect.update(mouse);
              let coors = rect.toRect();
            }
            draw();
          }
          _this.idAnimation = window.requestAnimationFrame(mainLoop);
        }
        function loadImage(url) {
          const image = new Image();
          image.src = url;
          image.onload = function() {
            canvas.width = this.width;
            canvas.height = this.height;
            refresh = true;
          };
          return image;
        }
        this.idAnimation = window.requestAnimationFrame(mainLoop);
        const canvas = document.getElementById("myArea");
        const ctx = canvas.getContext("2d");
        const baseImage = loadImage(this.forms);
        var refresh = true;
        const rect = (() => {
          var x1, y1, x2, y2;
          var show = false;
          function fix() {
            rect.x = Math.min(x1, x2);
            rect.y = Math.min(y1, y2);
            rect.w = Math.max(x1, x2) - Math.min(x1, x2);
            rect.h = Math.max(y1, y2) - Math.min(y1, y2);
          }
          function draw(ctx) {
            ctx.strokeRect(this.x, this.y, this.w, this.h);
            ctx.fillStyle = "rgba(0, 160, 225, 0.5)";
            ctx.fillRect(this.x, this.y, this.w, this.h);
          }
          const rect = { x: 0, y: 0, w: 0, h: 0, draw };
          const API = {
            restart(point) {
              x2 = x1 = point.x;
              y2 = y1 = point.y;
              fix();
              show = true;
            },
            update(point) {
              x2 = point.x;
              y2 = point.y;
              fix();
              show = true;
            },
            toRect() {
              show = false;
              return Object.assign({}, rect);
            },
            draw(ctx) {
              if (show) {
                rect.draw(ctx);
              }
            },
            show: false,
          };
          return API;
        })();
        const mouse = {
          button: false,
          x: 0,
          y: 0,
          down: false,
          up: false,
          element: null,
          event(e) {
            if (!_this.forms) {
              return false;
            }
            const m = mouse;
            m.bounds = m.element.getBoundingClientRect();
            m.x = e.pageX - m.bounds.left - scrollX;
            m.y = e.pageY - m.bounds.top - scrollY;
            const prevButton = m.button;
            m.button =
              e.type === "mousedown"
                ? true
                : e.type === "mouseup"
                ? false
                : mouse.button;
            if (!prevButton && m.button) {
              m.down = true;
            }
            if (prevButton && !m.button) {
              m.up = true;
            }
          },
          start(element) {
            mouse.element = element;
            "down,up,move"
              .split(",")
              .forEach((name) =>
                document.addEventListener("mouse" + name, mouse.event)
              );
          },
        };
        if (!this.flagEvent) {
          mouse.start(canvas);
          this.flagEvent;
        }
        this.loading = false;
      }, 1000);
    },
    permissionCheck() {
      let permissionArray = ["Gerente", "Administrador", "Superusuario"];
      let val = false;
      if (this.role.length > 0) {
        for (let i = 0; i < this.role.length; i++) {
          for (let j = 0; j < permissionArray.length; j++) {
            if (this.role[i] === permissionArray[j]) {
              val = true;
            }
          }
        }
      }
      this.multiplePermission = val;
    },

    viewArea(item) {
      this.areas = item.areas;
    },
    pointLocationH(item) {
      var img = document.getElementById("img");
      var altoOriginal = img.naturalHeight;
      var anchoDefinido = img.naturalWidth;

      return item.x;
    },
    getRepetitions() {
      services
        .ws("get", "typesRepetitions")
        .then((res) => {
          if (res.ok) {
            this.repeat = res.data;
            let mainRep = this.repeat.filter((rep) => rep.nombre == "Ninguna");
            this.noneRepetitionsId = mainRep[0].id;
          }
        })
        .catch((error) => {
          this.alertActive = true;
          this.alertMsg = error.response.data.message;
          this.alertType = "error";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getWorkplaces() {
      let auxArray = [];
      services
        .ws("get", "typesWorkplaces")
        .then((res) => {
          if (res.ok) {
            auxArray = res.data;
          } else {
            this.alertActive = true;
            this.alertMsg = res.message;
            this.alertType = "error";
          }
        })
        .catch((error) => {
          this.alertActive = true;
          this.alertMsg = error.response.data.message;
          this.alertType = "error";
        })
        .finally(() => {
          this.loading = false;
          this.reservationType = auxArray;
          this.newReservation += 1;
        });
    },
    getAreas() {
      let data = {
        ubicacionID: this.ubicacionId,
      };
      services
        .ws("get", "areas", data, "params")
        .then((res) => {
          if (res.ok) {
            this.clickInfo = res.data;
            this.newClick += 1;
          } else {
          }
        })
        .catch((error) => {
          this.alertActive = true;
          this.alertMsg = error.response.data.message;
          this.alertType = "error";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDetailsWorkPlace() {
      this.events = [];
      let init = moment(new Date(this.newForm["inicio"]))
        .utc()
        .format("yyyy-MM-DD");
      let data = {
        lugarTrabajoID: this.auxMap.id,
        zonaHoraria: moment_tz.tz.guess(),
        fecha: init,
      };
      services
        .ws("get", "workplace", data, "params")
        .then((res) => {
          if (res.ok) {
            this.workplaceDetail = res.data;

            for (
              let i = 0;
              i < this.workplaceDetail.reservaciones.length;
              i++
            ) {
              this.events.push({
                name: this.workplaceDetail.reservaciones[i].empleado.nombre,
                start:
                  init + " " + this.workplaceDetail.reservaciones[i].horaInicio,
                end: init + " " + this.workplaceDetail.reservaciones[i].horaFin,
              });
            }
          } else {
            this.alertActive = true;
            this.alertMsg = res.message;
            this.alertType = "error";
          }
        })
        .catch((error) => {
          this.alertActive = true;
          this.alertMsg = error.response.data.message;
          this.alertType = "error";
        })
        .finally(() => {
          let finish = moment(new Date(this.newForm["inicio"])).format(
            "yyyy-MM-DD HH:mm"
          );
          let secondsFinish =
            this.convertSecond(this.time) + this.newForm["duracion"];
          finish = moment(finish)
            .add(secondsFinish, "s")
            .utc()
            .format("yyyy-MM-DD HH:mm");
          this.events.push({
            name: this.userInfo.nombre + " " + this.userInfo.apellidoPaterno,
            start: this.newForm["inicio"] + " " + this.time,
            end: finish,
          });
          this.loading = false;
          this.sheet3 = !this.sheet3;
        });
    },
    selectDayBegin(info, name) {
      this.newForm[name] = info;
      this.newForm["fin"] = undefined;
    },
    selectDayEnd(info, name) {
      this.newForm[name] = info;
    },
    listInfo(info, name) {
      this.newForm[name] = info;
      if (name == "tipo") {
        this.cleanSelects = !this.cleanSelects;
        this.cleanSelectsRepeat = !this.cleanSelectsRepeat;
        this.newForm = {
          piso: {
            areas: undefined,
          },
          repite: undefined,
          tipo: this.newForm["tipo"],
          inicio: undefined,
          fin: undefined,
          area: undefined,
          capacidad: undefined,
          duracion: undefined,
        };
        this.other = false;
        this.otherId = undefined;
        this.time = null;
        this.arrayDays = [];
        this.days = [];
        this.hiddenCnavas = true;
      }
      if (name == "piso") {
        this.areasInfo = this.newForm[name]["areas"];
        this.checkArea = true;
        this.newArea += 1;
      }
      if (name == "area") {
        this.getCoor();
        this.hiddenCnavas = false;
      }
      if (name == "repite") {
        this.repeatActive = info.nombre;
      }
    },
    btnInfo(info, name) {
      if (name == "capacidad" && typeof info === "string") {
        let val = "";
        if (info.length == 6) {
          val = info[4] + info[5];
        } else {
          val = info[4];
        }
        if (info.length == 7) {
          val = info[5] + info[6];
        }
        this.newForm[name] = parseInt(val, 10);
      } else if (name == "duracion") {
        this.duration =
          info == "00:30"
            ? "30 Minutos"
            : info == "01:00" || info == "01:30"
            ? info + " Hora"
            : info + " Horas";
        this.newForm[name] = this.convertSecond(info);
      } else {
        this.newForm[name] = info;
      }
    },
    convertSecond(hour) {
      let stringsInfo = [hour[0] + hour[1], hour[3] + hour[4]];
      let seconds =
        parseInt(stringsInfo[0], 10) * 3600 + parseInt(stringsInfo[1], 10) * 60;
      return seconds;
    },
    getCoor() {
      let userId = VueJwtDecode.decode(this.$session.get("jwt"));
      let init = moment(new Date(this.newForm["inicio"] + " " + this.time))
        .utc()
        .format("yyyy-MM-DD HH:mm");
      let finish = moment(new Date(this.newForm["fin"] + " 00:00"))
        .endOf("day")
        .utc()
        .format("yyyy-MM-DD HH:mm");

      let data = {
        areaID: this.newForm["area"].id,

        fechaInicio: this.arrayDays.length > 0 ? this.arrayDays[0] : init,
        fechaFin:
          this.arrayDays.length > 0
            ? this.arrayDays[0]
            : this.newForm["repite"]
            ? this.newForm["repite"].id == this.noneRepetitionsId
              ? moment(init)
                  .endOf("day")
                  .utc()
                  .format("yyyy-MM-DD HH:mm")
              : finish
            : finish,
        horaInicio: this.time,
        empleado: this.otherId ? this.otherId : userId.employee.id,
        tipoLTID: this.newForm["tipo"].id,
        cantidadEmpleados: this.newForm["capacidad"]
          ? this.newForm["capacidad"]
          : this.newForm["tipo"].codigo[0] === "1"
          ? 1
          : 4,
        duracionDiaria: this.newForm["duracion"]
          ? this.newForm["duracion"]
          : 1800,
        tipoRepeticion: this.newForm["repite"]
          ? this.newForm["repite"].id
          : this.noneRepetitionsId,
        zonaHoraria: moment_tz.tz.guess(),
      };
      if (this.newForm["tipo"].codigo[0] === "1") {
        data.fechas =
          this.arrayDays.length > 0
            ? JSON.stringify(this.arrayDays)
            : JSON.stringify(arrayDate);
      }
      services
        .ws("get", "workplaces", data, "params")
        .then((res) => {
          if (res.ok) {
            this.workplaces = res.data.lugaresTrabajo;
          } else {
            this.alertActive = true;
            this.alertMsg = res.message;
            this.alertType = "error";
          }
        })
        .catch((error) => {
          this.alertActive = true;
          this.alertMsg = error.response.data.code;
          this.alertType = "error";
        })
        .finally(() => {
          this.loading = false;
          this.getLayout();
        });
    },
    onDayClick(day) {
      if (!day.isDisabled) {
        const idx = this.days.findIndex((d) => d.id === day.id);
        if (idx >= 0) {
          this.days.splice(idx, 1);
          this.arrayDays.splice(idx, 1);
        } else {
          this.days.push({
            id: day.id,
            date: day.date,
          });
          this.arrayDays.push(moment(day.date).format("YYYY-MM-DD"));
        }
      }
    },
    limitDay() {
      const date = new Date();
      return moment(date)
        .add(365, "days")
        .calendar();
    },
    getEmployees() {
      if (this.search && this.search != "") {
        let data = { texto: this.search ? this.search : "" };
        services
          .ws("get", "employees", data, "params")
          .then((res) => {
            if (res.ok) {
              this.employees = res.data;
              for (let index = 0; index < this.employees.length; index++) {
                this.employees[index] = {
                  fullName:
                    this.employees[index].nombre +
                    " " +
                    this.employees[index].apellidoPaterno,
                  id: this.employees[index].id,
                };
              }
            } else {
              this.alertActive = true;
              this.alertMsg = error.data;
              this.alertType = "error";
            }
          })
          .catch((error) => {
            this.alertActive = true;
            this.alertMsg = error.response.data.message;
            this.alertType = "error";
          });
      } else {
        this.employees = [];
      }
    },
    dataProfile() {
      services
        .ws("get", "profile")
        .then((res) => {
          if (res.ok) {
            this.userInfo = res.data;
          } else {
            this.alertActive = true;
            this.alertMsg = error.data;
            this.alertType = "error";
          }
        })
        .catch((error) => {
          this.codeError = error.response.data.code;
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    bootomModal() {
      if (this.openInfo) {
        if (this.auxMap.tipoLugarTrabajo.toLowerCase() == "sala de juntas") {
          this.getDetailsWorkPlace();
        } else {
          this.sheet2 = !this.sheet2;
        }
        this.spaceName = this.auxMap.nombre;
        this.spaceAvaible = this.auxMap.disponible;
        this.spaceReserv = this.auxMap.id;
      } else {
      }
    },
    createCart(type) {
      let data = {
        data: {
          lugarTrabajo: this.spaceReserv,
        },
      };
      services.ws("post", "cart", data).then((res) => {
        if (res.ok) {
          let userId = VueJwtDecode.decode(this.$session.get("jwt"));
          let begin, end, arrayDates;
          if (type == 1) {
            begin = this.arrayDays[0];
            end = this.arrayDays[0];
            arrayDates = JSON.stringify(this.arrayDays);
          } else {
            begin = moment(new Date(this.newForm["inicio"] + " " + this.time))
              .utc()
              .format("yyyy-MM-DD HH:mm");
            let finish = moment(new Date(this.newForm["fin"]))
              .endOf("day")
              .utc()
              .format("yyyy-MM-DD HH:mm");

            end = this.newForm["repite"]
              ? this.newForm["repite"].id == this.noneRepetitionsId
                ? moment(begin)
                    .endOf("day")
                    .utc()
                    .format("yyyy-MM-DD HH:mm")
                : finish
              : finish;
            arrayDates = null;
          }
          this.$router.push({
            path:
              "/client/AnotherReserve/" +
              this.ubicacionName +
              "/" +
              this.zone +
              "/" +
              this.areasInfo[0].piso +
              "/" +
              res.data.id,
            query: {
              fechaInicio: begin,
              fechaFin: end,
              fechas: arrayDates,
              lugaresInfo: JSON.stringify([this.auxMap]),
              horaInicio: this.time,
              empleado: this.otherId ? this.otherId : userId.employee.id,
              comentarios: "",
              lugaresTrabajo: [this.spaceReserv],
              lugarTrabajo: this.spaceReserv,
              cantidadEmpleados: this.newForm["capacidad"]
                ? this.newForm["capacidad"]
                : 1,
              duracionDiaria: this.newForm["duracion"]
                ? this.newForm["duracion"]
                : 1800,
              tipoRepeticion: this.newForm["repite"]
                ? this.newForm["repite"].id
                : this.noneRepetitionsId,
              zonaHoraria: moment_tz.tz.guess(),
            },
          });
        } else {
          this.alertActive = true;
          this.alertMsg = res.message;
          this.alertType = "error";
        }
      });
    },
  },
};
</script>

<style scoped>
.padding-b0 {
  padding-bottom: 0px;
}

.padding-t0 {
  padding-top: 0px;
}

.padding-t10 {
  padding-top: 3%;
}

.alignText {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

h1,
.colorLinde {
  color: #005591;
}

.colorLinde2 {
  color: #00a0e1;
}

.one {
  display: flex !important;
  align-items: flex-end !important;
}

.upImg {
  position: relative /* o absolute*/;
  top: 220px;
  left: 220px;
  z-index: 99;
}

.upImgG {
  position: relative /* o absolute*/;
  top: 220px;
  left: 320px;
  z-index: 99;
}
.contImg {
  width: 96%;
  max-width: 960px;
  margin: 0 auto;
}
v-img {
  width: 423px;
  height: 644px;
}
.scroll-container {
  height: 100%;
  overflow-y: scroll;
  overflow-x: scroll;
  backface-visibility: hidden;
}
</style>
